module.exports = __webpack_public_path__ + "img/business-france-logo-300x300.970386a1.png";